module.exports = __webpack_public_path__ + "item_2.svg?21195cb09e73976d5262df6ae63878eb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item_2.svg
// module id = 25
// module chunks = 0